module.exports = __webpack_public_path__ + "img/boat.be5030ca.webp";